<template>
  <div id="mypromote">
    <div class="mypromote-content">
      <div class="mypromote-banner">
        <img src="../../../static/images/mypromote-banner.jpg" alt="">
      </div>

      <div class="mypromote-main">

        <div class="mypromote-detail">
          
          <div class="mypromote-kh" v-html="mypromote_kh"></div>
          <div class="mypromote-icon">
            <img src="../../../static/images/mypromote-icon1.png" alt="">
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavDom from '@/components/navtop/navloginbefore'
export default {
  name: 'Mypromote',
  data() {
    return {
      mypromote_kh:"你想用自己的品牌去做推广,我们可以提供<br/>系统OEM服务，搭建自主平台快速推广,自己当老板。"
    }
  },
  created () {
    /*this.getConpy();*/
  },
  methods: {
    
  },
  components: {
    NavDom
  }
}
</script>

<style lang="stylus" scoped>
  .mypromote-banner
    img
      width 100%

  .mypromote-main
    width 1080px
    margin 0 auto

    .mypromote-detail
      margin 0 auto
      width 764px

      .mypromote-icon
        img
         width 100%

      .mypromote-kh
        margin 75px 0
        padding 20px
        font-size 30px
        color #000000
        text-align center
        line-height 60px

    
</style>



// WEBPACK FOOTER //
// src/components/service/mypromote.vue